import * as React from "react";
import BaseModal, { BaseModalContent } from "../BaseModal";
import AddPhoneNumberModalForm from "../../Forms/profile/AddPhoneNumberModalForm";
import PhoneIcon from "@material-ui/icons/Phone";

const AddPhoneNumberModal=(props)=>{ 
    const {isOpenAddPhoneNumberModal, handleCloseAddPhoneNumberModal} = props;
   
    return(
        <BaseModal
            title="Add Account Phone"
            align="center"
            icon={<PhoneIcon />}
            open={isOpenAddPhoneNumberModal}
            onClose={handleCloseAddPhoneNumberModal}
            fullWidth
            className="modal-header"
            disableBackdropClick
        >
            <BaseModalContent>
                <AddPhoneNumberModalForm handleClose={handleCloseAddPhoneNumberModal}/>
            </BaseModalContent>
        </BaseModal>
    );
};

export default AddPhoneNumberModal;